import BigNumber from 'bignumber.js';
import { ethers } from 'ethers';

export const GWEI = 9;

export const toChecksumAddress = (address: string) =>
  ethers.utils.getAddress(address);

export const toMaskedAddress = (address: string) =>
  address.substring(0, 6) +
  '...' +
  address.substring(address.length - 4, address.length);

export const toBN = (amount?: string | number | ethers.BigNumber) => {
  if (amount instanceof ethers.BigNumber) {
    amount = amount.toString();
  }
  if (!amount || amount === '') {
    amount = '0';
  }
  return new BigNumber(amount);
};

export const toWei = (amount: string, decimals: number) => {
  const UNIT = toBN(10).pow(decimals);
  return new BigNumber(amount).times(UNIT).toFixed(0);
};

export const fromBase64ToAscii = (base64EncodedData: string) => {
  const dataIndex = base64EncodedData.indexOf(',') + 1;
  const dataToDecode = base64EncodedData.substring(dataIndex);
  const buffer = Buffer.from(dataToDecode, 'base64');
  return buffer.toString('ascii');
};

export const parseBase64 = (dataBase64: string) => {
  const data = fromBase64ToAscii(dataBase64);
  return JSON.parse(data);
};
